import React, { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import { Bar } from '@ant-design/plots';
import "./scss/report.scss"
import { Table, Spin } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import { Tag } from "rsuite"
import StorageService from "../../utils/storage.service";
import Loading from "../customer/Loading";
import _ from "lodash"
import { Tooltip } from "antd";


const ReportServiceDetail = () => {
    const [title, setTitle] = useState("Tiền thu từng dịch vụ")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [chart, setChart] = useState([])
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState(null)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [totalProductOrder, setTotalProductOrder] = useState([])
    const [listCategoryIds, setSistCategoryIds] = useState([2, 4, 5, 45, 46, 47, 53, 54, 1000])
    const [totalMyPham, setTotalMyPham] =   useState(0)
    const [totalDeposit, setTotalDeposit] = useState(0)
    const [optionCategory, setOptionCategory] = useState([])
    const [catId, setCatId] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [typeBHVV, setTypeBHVV] = useState(0)

    const handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }

    const handleCategory = (x) => {
        setCatId(x)
    }

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store, keyword, catId, typeBHVV])

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        {
            title: 'Tên dịch vụ',
            dataIndex: 'product_name',
            render: (data) => {
                return (<p>{data}</p>)
            },
        },
        {
            title: 'Nhóm dịch vụ',
            dataIndex: 'category_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            dataIndex: 'total_paid',
            align: "center",
            title: <span className="show-tooltip">
                <Tooltip title='Là tổng số tiền thu được từ các hoạt động bán thẻ dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ qua các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'> 
                    Tổng tiền đã thu
                </Tooltip>
            </span>,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.total_paid - b.total_paid,
                multiple: 3,
            },
        },
        {
            dataIndex: 'total_paid_no_tax',
            align: "center",
            title: <span className="show-tooltip">
                <Tooltip title='Tổng tiền đã thu trừ VAT'> 
                    Tổng thực thu bán hàng
                </Tooltip>
            </span>,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.total_paid_no_tax - b.total_paid_no_tax,
                multiple: 3,
            },
        },
        {
            title: 'Số dịch vụ bán mới',
            dataIndex: 'count_order',
            align: "center",
            title: <Tooltip className="show-tooltip" title='Tổng sô lượng bán mới của dịch vụ.'> Số dịch vụ bán mới</Tooltip>,
            render: (data) => {
                return (
                    <p className="text1">{Number(data)}</p>
                )
            },
        },
        {
            title: 'Doanh số thuần',
            title: <Tooltip title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Được tại trong khoảng thời gian trọn.'> Doanh số thuần </Tooltip>,
            dataIndex: 'total_price',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.total_price - b.total_price,
                open: false,
                multiple: 3,
            },
        },
    ];

    const fetchData = async (sD, eD, s) => {
        let payload = {
            start: sD,
            end: eD,
            store: s,
            keyword: keyword,
            catId: catId,
            typeBHVV
        }

        const res = await axiosService(`api/mysql/report-detail-service/all`, "POST", payload)

        if (res.data.code === 200) {
            const { dataTable, dataCategory, optionCategory } = res.data.data
            setTable(dataTable)
            setOptionCategory(optionCategory)

            let dataSort = []
            for (let item of dataCategory) {
                item.sum_paid_order_item = Number(item.sum_paid_order_item)
                dataSort.push(item)
            }

            if (dataCategory.length > 0) {
                let totalMyPham = 0
                let totalDeposit = 0
                for (let o of dataCategory) {
                    if (o.category_id && !listCategoryIds.includes(o.category_id)) {
                        totalMyPham += Number(o.sum_paid_order_item)
                    }
                    if (o.category_id == 50 || !o.category_id) {
                        totalDeposit += Number(o.sum_paid_order_item)
                    }
                }
                dataSort.push({sum_paid_order_item: totalMyPham, category_id: 1000, category_name: "Mỹ Phẩm"})

                setTotalMyPham(totalMyPham)
                setTotalDeposit(totalDeposit)
            }
            dataSort = _.orderBy(dataSort, ['sum_paid_order_item'], ['desc']);
            setTotalProductOrder([...dataSort])

            setLoading(false)
        }
    }

    const handleExportData = async () => {
        setLoading(true)

        let payload = {
            start: startDate,
            end: endDate,
            store: store,
            keyword: keyword,
            catId: catId,
            typeBHVV: typeBHVV,
            type: 1
        }

        const res = await axiosService(`api/mysql/report-detail-service/all`, "POST", payload)
        if (res.data.code === 200) {
            window.location.href = res.data.data.url
        } 
        
        setLoading(false)
    }

    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    return (
        <div className={`${styles.background} container-fluid`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} 
                store={store}
                handleStore={handleStore}
                title={title} type={"report-detail-service"}
                typeBHVV={typeBHVV} setTypeBHVV={setTypeBHVV}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                header={
                    [
                        
                        { label: 'Tên dịch vụ', key: "product_name" },
                        { label: "Nhóm dịch vụ", key: "category_name" },
                        { label: "Tiền thực thu dịch vụ", key: "total_paid" },
                        { label: "Số dịch vụ bán mới", key: "count_order" },
                        { label: "Doanh số thuần", key: "total_price" },
                    ]
                }
                userAdmin={userAdmin}
                optionCategory={optionCategory}
                handleCategory={handleCategory}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col xs={12} md={8}>
                        <Row className="mh-172">
                            <Col xs={6}>
                                <Tag color="green" className=" w-100 h-100 p-2">
                                    <p className={styles.textTag2}>
                                        <Tooltip title='Tổng số tiền thu được từ các hoạt động bán thẻ dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ qua các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'>
                                            Tổng tiền đã thu <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </p>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                        {totalProductOrder?.map((x,y) => (
                                            listCategoryIds.includes(x.category_id) ?
                                                <p key={y} className={styles.textTag3}>{x.category_name }</p> : null
                                            ))
                                        }
                                        </div>
                                        <div>
                                            {totalProductOrder.map((x,y) => (
                                                listCategoryIds.includes(x.category_id) ?
                                                    <p key={y} className={styles.textTag2}>{convertCurrency(x.sum_paid_order_item || 0)}</p> : null
                                                ))
                                            }
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6}>
                                <Tag color="blue" className=" w-100 h-100 p-2">
                                    <p className={styles.textTag2}>
                                        <Tooltip title='Tổng tiền đã thu trừ VAT'>
                                            Tổng thực thu bán hàng <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </p>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                        {totalProductOrder?.map((x,y) => (
                                            listCategoryIds.includes(x.category_id) ?
                                                <p key={y} className={styles.textTag3}>{x.category_name}</p> : null
                                            ))
                                        }
                                        </div>
                                        <div>
                                            {totalProductOrder.map((x,y) => (
                                                listCategoryIds.includes(x.category_id) ?
                                                    <p key={y} className={styles.textTag2}>{convertCurrency(x.sum_paid_order_item_no_tax || 0)}</p> : null
                                                ))
                                            }
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} className="mt-3">
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <div className="border-bottom w-100 mb-2">
                                <strong>Bảng số liệu chi tiết</strong>
                            </div>
                            <Table 
                                columns={columns}
                                dataSource={table}
                                onChange={handleChange}
                                showSorterTooltip={{ title: '' }}
                                pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50', '100'] }}
                                scroll={{ x: 1300 }}
                                bordered
                                rowKey={'product_id'}
                            />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}
export default ReportServiceDetail